import { t } from 'i18next';
import React, { useEffect } from 'react';
import { IFeaturesEditable, IFeaturesEditablePathSource } from '../../../../interface/interfaces';
import { PanelLayout } from '../../../layout/Panel/Panel';
import { SpacingCustom } from '../../../layout/Spacing/SpacingCustom';
import { ExecButton } from '../../../ui/ExecButton/ExecButton';
import { TextCustom } from '../../../ui/TextCustom';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { useWebSocket } from '../../WebSocket/hooks/useWebSocket';
import { useSendWebsocketMessage } from '../../WebSocket/hooks/useSendWebsocketMessage';
import { WEBSOCKET_PARAMETERS } from '../../../../constants/constants';
import { Loader } from '../../../shared/Loader/Loader';
import { rootState } from '../../../../redux/store';
import toast from 'react-hot-toast';
import { removeAllPaths } from '../../UserSettings/FilePath/userSettingsFilePathFastChanging.slice';
import { SeparatorLine } from '../../../shared/Separators/SeparatorLine';
import { FlexCenter } from '../../../layout/FlexCenter/FlexCenter';
import { Badge } from '../../../shared/Badge/Badge';
import { GridTable } from '../../../layout/GridTable/GridTable';

interface IToolConfigProps {
    tools: IFeaturesEditable[];
    index: number[];
    setTools: React.Dispatch<React.SetStateAction<IFeaturesEditable[]>>;
    setIndex: React.Dispatch<React.SetStateAction<number[]>>;
    collectedTools: IFeaturesEditablePathSource[]
}

export const ToolConfig: React.FC<IToolConfigProps> = ({ tools, index, setTools, setIndex, collectedTools}) => {
    const { socketRef } = useWebSocket('Tool config');
    const { sendWebsocketMessage } = useSendWebsocketMessage(socketRef);

    const dispatch = useAppDispatch();
    const [selectedTool, setSelectedTool] = React.useState<string>('');
    
    const {userSettingsFilePathLoading, userSettingsFilePathError} = useAppSelector((state: rootState) => state.userSettingsFilePath);


    // const {userSettingsAllFilePathData} = useAppSelector((state:rootState)=>state.userSettingsAllFilePath)
    
    // useEffect(()=>{
    //     console.log('userSettingsAllFilePathData', userSettingsAllFilePathData)
    // },[userSettingsAllFilePathData])

    const onInputChange = (e: React.ChangeEvent<HTMLInputElement>, idx: number) => {
        const newTools = [...tools];
        newTools[idx].DefaultLocation = e.target.value;
        setTools(newTools);
    };

    const setToolPath = (idx: number) => {
        
        const newTools = [...tools];
        newTools[idx].isEditable = true;
        setIndex([...index, idx]);
        setTools(newTools);
        setSelectedTool(newTools[idx].Tool);
        
        sendWebsocketMessage(JSON.stringify({parameter: WEBSOCKET_PARAMETERS.USER_SETTINGS_FILE_PATH, tool:newTools[idx].Tool}));
    };

    useEffect(() => {
        if (userSettingsFilePathError) {
            toast.error('Failed to connect to the server');
            dispatch(removeAllPaths())
        }
    },[userSettingsFilePathError, dispatch])


    const toolConfig = collectedTools.map((item: IFeaturesEditablePathSource, idx: number) => {
        return (
            <GridTable key={idx} gridTemplateColumns='180px 1fr max-content'>


                            <SpacingCustom marginLeft={1}>
                                <TextCustom color="dark" size={1.2} weight={700}>
                                    {item.Tool}
                                </TextCustom>
                            </SpacingCustom>
                            <div>
                                <SpacingCustom marginTop={0.4} marginBottom={0.4} marginLeft={1} marginRight={0.5}>
                                    <FlexCenter direction='v' position='center' gap={0.5}>
                                        <Badge radius='s' label={`${!item.isDefaultLocation ? 'Edited' : 'Default'}`} color={`${!item.isDefaultLocation ? 'accent-orange' : 'grey-normal'}`} />
                                        <input
                                            className={`
                                                input-tools 
                                                input-tools__selected 
                                                ${(!item.DefaultLocation || (userSettingsFilePathLoading && item.Tool === selectedTool)) && 'input-tools__not-found'}
                                                ${(userSettingsFilePathError) && 'input-tools__error'}
                                                `
                                            }
                                            type="text"
                                            value={
                                                (userSettingsFilePathError)
                                                ?
                                                'Failed to connect to the server. Please, restart app and try again.'
                                                : item.DefaultLocation ||  t('settings.featuresSettingsPathNotFound')

                                            }
                                            onChange={(e) => onInputChange(e, idx)}
                                            readOnly
                                        />
                                    </FlexCenter>
                                </SpacingCustom>
                            </div>
                                    
                            {
                                userSettingsFilePathLoading && item.Tool === selectedTool
                                ?
                                <Loader color="dark" width={15} height={15} />
                                :
                                <ExecButton label={t('buttons.setPath')} textColor="grey-dark" size="m" showIcon={true} iconSize={1.4} iconName={'Edit'} func={() => setToolPath(idx)} />
                            }
                            

            </GridTable>
        );
    });

    return <>{toolConfig}</>;
};
